import {useApi} from "../Api";
import {PagedResponse} from "../types/pagination";
import {
    FormSearchLocationGroupModel,
    LocationGroupEntityRequest,
    LocationGroupEntityResponse
} from "../types/locationGroup";
import {buildQueryParams} from "../../utils";

export const useLocationGroupRepository = () => {
    const {GET, POST, PUT, DELETE} = useApi();

    const PATH = "/pricing/location-groups";

    function getLocationGroup(id: number): Promise<LocationGroupEntityResponse> {
        return GET(`${PATH}?id=${id}`);
    }

    function getLocationGroups(legalEntity?: string): Promise<LocationGroupEntityResponse[]> {
        return GET(`${PATH}/filter/list?legalEntities=${legalEntity}`);
    }

    function putLocationGroup(locationGroupEntityResponse: LocationGroupEntityResponse): Promise<LocationGroupEntityResponse> {
        return PUT(`${PATH}`, locationGroupEntityResponse);
    }

    function postLocationGroup(locationGroupEntityRequest: LocationGroupEntityRequest): Promise<LocationGroupEntityResponse> {
        return POST(`${PATH}`, locationGroupEntityRequest);
    }

    function deleteLocationGroup(locationGroupId: number): Promise<number> {
        return DELETE(`${PATH}?id=${locationGroupId}`);
    }

    function getLocationGroupsPaged(filters: FormSearchLocationGroupModel): Promise<PagedResponse<LocationGroupEntityResponse>> {
        const query = "?";

        const queryParams = buildQueryParams(filters);

        return GET(`${PATH}/filter${queryParams ? query + queryParams : ""}`);
    }

    return {
        getLocationGroup,
        getLocationGroups,
        putLocationGroup,
        postLocationGroup,
        deleteLocationGroup,
        getLocationGroupsPaged
    };
};